// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"7d447e51","732":"a2cc9030","977":"68f58b03"}[chunkId] + ".chunk.js";
};